import React, {PropTypes} from 'react'
import {Provider} from 'react-redux'
import routes from '../routes'
//import DevTools from './DevTools'
import {Router} from 'react-router'

const Root = ({store, history}) => (
    <Provider store={store}>
        <div>
            <Router history={history} routes={routes} />
            
        </div>
    </Provider>
)

Root.propTypes = {
    store: PropTypes.object.isRequired,
    history: PropTypes.object.isRequired
}

export default Root


// WEBPACK FOOTER //
// ./src/containers/Root.js